import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CtaItemType } from '@/components/CtaItem/CtaItem';
import ButtonClose from '@/components/ButtonClose/ButtonClose.vue';
import Trap from 'vue-focus-lock';

import SvgImage from '../SvgImage/SvgImage.vue';
import DeckTab from '../DeckTab/DeckTab.vue';
import DeckCategory from '../DeckCategory/DeckCategory.vue';
import { DecksAndCabinsModuleState } from '../DecksAndCabinsModule.store';
import { BREAKPOINTS } from '@/common/interfaces/SizeBreakpoints';

import FocusTrapDirective from '@/directives/FocusTrapDirective';

// import DottedLine from '@/assets/icons/dotted-line-2.svg?inline';
@Component({
  components: {
    SvgImage,
    ButtonClose,
    DeckTab,
    DeckCategory,
    Trap,
  },
  directives: {
    'trap-focus': FocusTrapDirective,
  },
})
export default class DeckViewComponent extends Vue {
  @Prop()
  readonly state!: DecksAndCabinsModuleState;

  @Prop({ type: Array as () => CtaItemType[], default: () => [] })
  readonly bookCtaItems!: CtaItemType[];

  windowWidth: number = 0;

  get deck() {
    return this.state && this.state.CurrentDeck ? this.state.CurrentDeck.Deck : null;
  }

  get currentCabinCode() {
    return this.state.CurrentCabinCode;
  }

  get shipName() {
    return this.state && this.state.CurrentDeck ? this.state.CurrentDeck.ShipName : '';
  }

  get currentCategory() {
    return this.state.CurrentDeckCategory;
  }

  get getBreakpoint() {
    return BREAKPOINTS;
  }

  deckTab: string = 'deckTab';
  infoTab: string = 'infoTab';
  currentTab: string = '';

  close() {
    this.$emit('close');
  }

  setTab(tab: string) {
    this.currentTab = tab;
  }

  isActiveTab(tab: string) {
    return this.currentTab === tab;
  }

  setCurrentDeckCategory(category: any) {
    this.$emit('setCurrentDeckCategory', category);
  }

  isActiveCategory(id: number) {
    const currCat = this.currentCategory;
    return currCat && currCat.Category && currCat.Category.Id === id;
  }

  handleResizeEvent() {
    let newWidth = document.documentElement.clientWidth;
    this.windowWidth = newWidth;
  }

  svgHeight: string | number = 'auto';
  deckPosition: string | number = 'auto';

  getSvgHeight() {
    let deck: any = <HTMLElement>document.querySelector('.deck__pictureWrapper');

    if (deck) {
        let deckWidth = deck.offsetWidth;
        let deckHeight = deck.offsetHeight;

        this.svgHeight = deckWidth - deckHeight;
    }
  }

  getShipPosition() {
    let deck: any = <HTMLElement>document.querySelector('.deck__pictureWrapper');
    let deckItem: any = <HTMLElement>document.querySelector('.deck__item--picture');

    if (deck) {
      let deckWidth = deck.offsetWidth;
      let deckItemWidth = deckItem.offsetWidth;

      if (this.windowWidth < this.getBreakpoint.xl) {
        this.deckPosition = (deckWidth - this.windowWidth)/2 + this.getScrollWidth();
      } else {
        this.deckPosition = (deckWidth - deckItemWidth)/2 + this.getScrollWidth();
      }
    }
  }

  getScrollWidth() {
    let div: any = document.createElement('div');

    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';

    document.body.append(div);

    let scrollWidth = div.offsetWidth - div.clientWidth;
    div.remove();

    return scrollWidth;
  }

  mounted() {
    this.currentTab = this.deckTab;

    window.addEventListener('resize', () => {
      this.handleResizeEvent();
      this.getSvgHeight();
      this.getShipPosition();
    });

    this.handleResizeEvent();
    this.getScrollWidth();
  }

  updated() {
    this.getSvgHeight();
    this.getShipPosition();
  }

  destroyed() {
    window.removeEventListener('resize', () => {
      this.handleResizeEvent();
      this.getSvgHeight();
      this.getShipPosition();
    });
  }
}
